import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { fetchCarbonCreditListings, CarbonCreditListing } from '../../services/carbonCreditService';
import './CarbonTicker.css';

const CarbonTicker: React.FC = () => {
  const [listings, setListings] = useState<CarbonCreditListing[]>([]);

  useEffect(() => {
    fetchCarbonCreditListings().then(setListings);
  }, []);

  return (
    <Box
      className="carbon-ticker"
      sx={{ bgcolor: 'background.paper' }}
      aria-label="Carbon credit listings ticker"
      tabIndex={0}
      onMouseEnter={() => {
        const ticker = document.querySelector('.ticker-content');
        if (ticker) ticker.classList.add('paused');
      }}
      onMouseLeave={() => {
        const ticker = document.querySelector('.ticker-content');
        if (ticker) ticker.classList.remove('paused');
      }}
      onFocus={() => {
        const ticker = document.querySelector('.ticker-content');
        if (ticker) ticker.classList.add('paused');
      }}
      onBlur={() => {
        const ticker = document.querySelector('.ticker-content');
        if (ticker) ticker.classList.remove('paused');
      }}
    >
      <Box className="ticker-content">
        {listings.map((item) => (
          <Typography key={item.id} variant="body2" component="span" sx={{ mx: 2 }}>
            {item.seller} - ${item.price}/t ({item.trend === 'up' ? '▲' : '▼'})
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default CarbonTicker;
